import React from 'react';
import { CheckboxHeaderComponentProps } from './checkbox-row-component.types';
import ThreeStateCheckbox from '../../../../components/three-state-checkbox';

const CheckboxRowComponent = ({ changeCheckboxHandler, row, checkedLeasingOffers }: CheckboxHeaderComponentProps) => {
  const isChecked = checkedLeasingOffers.some(item => item === row.id);

  return (
    <ThreeStateCheckbox
      checked={isChecked}
      onChange={checkboxState => changeCheckboxHandler(row.id, checkboxState)}
      indeterminate={false}
    />
  );
};

export default CheckboxRowComponent;
